import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedUiTableModule } from '@snelstart/ui-table';
import {FeatureTaxDonationListComponent} from "./tax-donation-list/feature-tax-donation-list.component";
import {SharedUiButtonModule} from "@snelstart/ui-button";

@NgModule({
  imports: [CommonModule, SharedUiTableModule, SharedUiButtonModule, FeatureTaxDonationListComponent],
  declarations: [],
  exports: [FeatureTaxDonationListComponent],
})
export class FeatureTaxDonationListModule {}
